import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import ParameterListView from 'src/views/parameter/ParameterListView';

const ParameterView = () => (
  <RolePrivateRoute component={ParameterListView} />
);

export default ParameterView;
